import React from 'react';
import { WrappedComponentProps, FormatNumberOptions } from 'react-intl';

import { abbreviateNumber } from '../core/utils';

export interface OwnProps {
  style: FormatNumberOptions['style'];
  currency: string;
  value: number;
  maxDigits: number;
  includeDecimals?: boolean;
}

export type Props = OwnProps & WrappedComponentProps;

export const AbbreviatedNumberComponent = (props: Props) => {
  const { value, maxDigits, style, currency, includeDecimals, intl } = props;

  return <span>{abbreviateNumber(value, maxDigits, style, currency, includeDecimals, intl)}</span>;
};
